import React from "react";
import Card from "../UI/Card";
import ButtonLink from "../UI/ButtonLink";
import Button from "../UI/Button";
import CountryImage from "./CountryImage";

import classes from "./Country.module.css";

import { Link } from "react-router-dom";

import NavBarContext from "../../store/navbar-context";
import { useContext, useEffect } from "react";

const Country = (props) => {
  const navCtx = useContext(NavBarContext);

  useEffect(() => {
    navCtx.show();
  }, [navCtx]);

  const onClickHandler = () => {
    navCtx.hide();
  };

  return (
    <Card>
      <div className={classes.wrapper} id={props.id}>
        <div className={classes.label}>
          <h1>{props.title}</h1>
          <ButtonLink label="Website" src={props.website} />
        </div>
        <div className={classes.regularText}>
          <CountryImage photo={props.photo} />
        </div>
        <div className={classes.text}>
          {props.text.pl.length > 0 || props.text.en.length > 0 ? (
            <div>
              {props.text.pl && <p>{props.text.pl}</p>}
              <br />
              <p>{props.text.en}</p>
            </div>
          ) : (
            <p className={classes.regularText}>Description Coming Soon</p>
          )}
        </div>
        <div className={`${classes.activities} ${classes.regularText}`}>
          <Link to={`/country/${props.id}/act`}>
            <Button
              onClick={onClickHandler}
              label={"School Project Activities"}
            />
          </Link>
          {!props.activities && <p>Coming Soon</p>}
        </div>
        <div className={`${classes.meeting} ${classes.regularText}`}>
          <Link to={`/country/${props.id}/meet`}>
            <Button onClick={onClickHandler} label={"Project Meeting"} />
          </Link>
          {!props.meeting && <p>Coming Soon</p>}
        </div>
      </div>
    </Card>
  );
};

export default Country;
